<template>
  <span v-if="state" class="receipt-check-status" :class="`receipt-check-status--${state}`">
    <span class="receipt-check-status__state">
      <span class="receipt-check-status__dot"></span>
      <span>{{ helper.trans(`dispute_reason.${reason}`) }}</span>
    </span>
    <span v-for="text in reasons" :key="text" class="receipt-check-status__reason">{{ text }}</span>
  </span>
</template>

<script lang="ts">

import {computed, defineComponent, PropType} from 'vue'
import {helper} from "@/service/CommonHelper";
import {DisputeReason} from "@/models/enum/DisputeReason";

export default defineComponent({
  name: "ReceiptCheckStatus",
  props: {
    reason: {
      type: String as PropType<DisputeReason|string|null>,
      default: null
    },
    data: {
      type: Object as PropType<any>,
      default: null
    },
  },
  setup(props) {
    const state = computed((): 'checking'|'passed'|'failed'|null => {
      switch (props.reason) {
        case DisputeReason.RECEIPT_CHECKING:
          return 'checking'
        case DisputeReason.RECEIPT_CHECK_PASSED:
          return 'passed'
        case DisputeReason.RECEIPT_CHECK_FAILED:
          return 'failed'
        default:
          return null
      }
    })

    const reasons = computed((): string[] => {
      if (state.value !== 'failed' || !props.data) {
        return []
      }

      if (props.data.result === 'error') {
        return [helper.trans('stopscam.checker_unavailable')]
      }

      const verdicts: string[] = Array.isArray(props.data.verdicts) ? props.data.verdicts : []

      return verdicts.map((verdict) => helper.trans(`stopscam.verdict.${verdict}`, {}, verdict))
    })

    return {
      helper,
      state,
      reasons,
    }
  }
})
</script>

<style scoped>
.receipt-check-status {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  font-size: 80%;
  line-height: 1.25;
}

.receipt-check-status__state {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-weight: 600;
  text-transform: none;
}

.receipt-check-status__dot {
  flex: 0 0 auto;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: currentColor;
}

.receipt-check-status__reason {
  padding-left: 13px;
  text-transform: none;
}

.receipt-check-status--checking {
  color: #b58105;
}

.receipt-check-status--checking .receipt-check-status__dot {
  animation: receipt-check-status-pulse 1.2s ease-in-out infinite;
}

.receipt-check-status--passed {
  color: #198754;
}

.receipt-check-status--failed {
  color: #dc3545;
}

@keyframes receipt-check-status-pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.25;
  }
}
</style>
